module.exports = __webpack_public_path__ + "img/744.b4873c90.jpg";